import React, { useCallback } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PriceSection } from './components/PriceSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
const CHECKOUT_URL = 'https://libresdeser.com/checkout';
export function App() {
  const handleCheckout = useCallback(() => {
    window.location.assign(CHECKOUT_URL);
  }, []);
  return <div className="min-h-full w-full bg-white font-sans text-ink" data-id="element-0" data-mp="31b8jvzet8d9q">
      <Hero data-id="element-1" data-mp="31cjo20c63n1d" />
      <main data-id="element-2" data-mp="2wk06ksad07ra">
        <PainSection data-id="element-3" data-mp="2wjgrrkg09zhh" />
        <BenefitsSection data-id="element-4" data-mp="2wiyvwox99na3" />
        <PriceSection onBuy={handleCheckout} data-id="element-5" data-mp="2wip7h5ruzo6i" />
        <TestimonialsSection data-id="element-6" data-mp="28tw5arkn8k3g" />
        <FaqSection data-id="element-7" data-mp="28t4l0cwhy8sh" />
      </main>
      <Footer data-id="element-8" data-mp="28s2xva27hvue" />
    </div>;
}